module.exports = __webpack_public_path__ + "img/cd8bf2f8e6272e307d48b4474f67b805.b2aebe54.jpg";